import { gql, useQuery } from '@apollo/client';
import type {
  ExternalSearchSourcesQuery,
  ExternalSearchSourcesQueryVariables,
  UseTeamSearchSources_IntegrationFragment,
} from '../../graphql/generated/graphqlTypes';
import { IntegrationFeatureStatus } from '../../graphql/generated/graphqlTypes';
import { INSTALLABLE_PLATFORM_INFO_MAP } from '../../integrations/IntegrationPlatformInfo';

const SEARCH_SOURCES_QUERY = gql`
  query externalSearchSources($platform: String!) {
    sources: externalSearchSources(platform: $platform) {
      id
      name
    }
  }
`;

const INTEGRATION_FRAGMENT = gql`
  fragment useTeamSearchSources_integration on Integration {
    id
    platform
    features {
      teamSearch
    }
  }
`;

const useTeamSearchSources = ({
  features,
  platform,
}: UseTeamSearchSources_IntegrationFragment) => {
  const teamSearchPlatform =
    INSTALLABLE_PLATFORM_INFO_MAP[platform]?.teamSearchPlatform;

  return useQuery<
    ExternalSearchSourcesQuery,
    ExternalSearchSourcesQueryVariables
  >(SEARCH_SOURCES_QUERY, {
    fetchPolicy: 'network-only',
    skip: features?.teamSearch !== IntegrationFeatureStatus.Enabled,
    variables: { platform: teamSearchPlatform || platform },
  });
};
useTeamSearchSources.fragments = {
  integration: INTEGRATION_FRAGMENT,
};

export default useTeamSearchSources;
